 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"63443773fabd07c22ead17ba7a09656d11d50b08","2":"9dea0c68d569c2366855dbb55de827f9659a19d6","3":"3afd1070ac61e8ec84eb60228820d3198f21798c","4":"d0e178a0b7a174cc355912fab2c2b5dbf6686e47","5":"c1fa102fc68144c3dc979a25ee723cb571f93e62","6":"f54b42984bfe4d114461fcea2710af414ac1fe74","7":"9623c8bfb4e1a9580b19ea1c8af106c4cecf0df4","9":"05d95cbf","10":"2163a37f","11":"2f3f3ddc","12":"52be02c1","13":"54ad46ca","14":"57e3b744","15":"632b773a","16":"72bb63b0","17":"955ea283","19":"b55e3731","20":"c47df2eb","21":"component---cache-caches-gatsby-plugin-offline-app-shell-js","22":"component---src-pages-404-js","23":"component---src-pages-about-js","24":"component---src-pages-chess-js","25":"component---src-pages-coding-archived-js","26":"component---src-pages-coding-js","27":"component---src-pages-eighth-js","28":"component---src-pages-french-js","29":"component---src-pages-index-js","30":"component---src-pages-languagearts-6-js","31":"component---src-pages-languagearts-7-js","32":"component---src-pages-languagearts-8-js","33":"component---src-pages-math-6-js","34":"component---src-pages-math-7-js","35":"component---src-pages-math-8-js","36":"component---src-pages-mobilemenu-js","37":"component---src-pages-resources-js","38":"component---src-pages-science-6-js","39":"component---src-pages-science-7-js","40":"component---src-pages-science-8-js","41":"component---src-pages-seventh-js","42":"component---src-pages-sixth-js","43":"component---src-pages-socialstudies-6-js","44":"component---src-pages-socialstudies-7-js","45":"component---src-pages-socialstudies-8-js","46":"component---src-pages-spanish-js","47":"component---src-pages-termsofuse-js","48":"component---src-pages-timer-20-js","49":"component---src-templates-article-js","50":"component---src-templates-articles-js","51":"component---src-templates-subjects-js","52":"e9227503"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"5bdf15d142db46b55643","2":"48912d6aa95da8ffcf33","3":"c371896bb9c68849a39f","4":"84550dcb9533fe14a3b3","5":"9b6aa9403fa93e1f3b90","6":"e7bfac276e6a7ce807af","7":"0f5083bb00fc435077ec","9":"5753fd19f78004556e01","10":"0910073cb807a76ddf1c","11":"8d46a62a05b116bd72a4","12":"9e63a79ba05d2581e3d1","13":"fee0b4b692705df3e768","14":"985cc7de235dd01ccbab","15":"2f3202b855e9977d8fd0","16":"69967feac3d7641396a8","17":"d8574f3ad16b77dcce86","19":"b70503937f3343a2a451","20":"787e88e9c86e03c88c54","21":"0cdd30da6e98f04d1023","22":"27d54691e7f26befe054","23":"a15715108108f4f2f656","24":"917fbd03ab9cc07efe5f","25":"6894847b5cf65ced4bae","26":"d1200bc5dfd25ec38047","27":"3d3ce9e933248c692ce0","28":"fc4a876544a46787570b","29":"8a6ddff183900ec65778","30":"f17decc95cb4e99388f8","31":"fd40932f48cc2590a0fb","32":"ccf9462ef43dd66867af","33":"348d496ea41799df2059","34":"506392c985904696af7a","35":"cedce81f1c4198b21cf3","36":"aa84f3ee1aba4e7da8db","37":"512bc4749ff25e15c5c1","38":"9f9be5c2ea7ae09951ff","39":"bc228a2be4fbcfc6a93a","40":"8dc0d1bdcb91740e280c","41":"dafbd049cc1e5f8644a3","42":"870829f03d3979576374","43":"bc2d72b6f09102098712","44":"16e90e016d2b4cdd54a9","45":"0ac0d6a8811d1c8bd4cc","46":"041180c656bb34d52ebe","47":"77244d0a862f703f2f3d","48":"36ba0eba7367ad29e1d9","49":"683d3d3879c307a2f8b3","50":"e486c4aadfea144551eb","51":"39ed0d0db216990391f5","52":"4c60e0e37a1def9bd17f","55":"29acb930b3fa303323ea","56":"455b596559031be322c9","57":"965b47723f51a57aaf90","58":"0db9becacba67875a55b","59":"43fbb388ab6b3b27af60","60":"e8372ff97d5406dc80bb","61":"f130a8ad3d668d0b9862","62":"c1274b7046272b6d4dcd","63":"131223f17be497df4b0e","64":"ffbe5ebfecd004d221fd","65":"5b4e31cd9658c738cc73","66":"38e07b4878c109f7c540","67":"004ff181f022a92c99fc","68":"19b0979737447bde2b92","69":"71bd6dccc92e921380ff","70":"b8e922c08355439f1695","71":"aa0906bc66677ad7b1c1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"63443773fabd07c22ead17ba7a09656d11d50b08","2":"9dea0c68d569c2366855dbb55de827f9659a19d6","3":"3afd1070ac61e8ec84eb60228820d3198f21798c","4":"d0e178a0b7a174cc355912fab2c2b5dbf6686e47","5":"c1fa102fc68144c3dc979a25ee723cb571f93e62","6":"f54b42984bfe4d114461fcea2710af414ac1fe74","7":"9623c8bfb4e1a9580b19ea1c8af106c4cecf0df4","9":"05d95cbf","10":"2163a37f","11":"2f3f3ddc","12":"52be02c1","13":"54ad46ca","14":"57e3b744","15":"632b773a","16":"72bb63b0","17":"955ea283","19":"b55e3731","20":"c47df2eb","21":"component---cache-caches-gatsby-plugin-offline-app-shell-js","22":"component---src-pages-404-js","23":"component---src-pages-about-js","24":"component---src-pages-chess-js","25":"component---src-pages-coding-archived-js","26":"component---src-pages-coding-js","27":"component---src-pages-eighth-js","28":"component---src-pages-french-js","29":"component---src-pages-index-js","30":"component---src-pages-languagearts-6-js","31":"component---src-pages-languagearts-7-js","32":"component---src-pages-languagearts-8-js","33":"component---src-pages-math-6-js","34":"component---src-pages-math-7-js","35":"component---src-pages-math-8-js","36":"component---src-pages-mobilemenu-js","37":"component---src-pages-resources-js","38":"component---src-pages-science-6-js","39":"component---src-pages-science-7-js","40":"component---src-pages-science-8-js","41":"component---src-pages-seventh-js","42":"component---src-pages-sixth-js","43":"component---src-pages-socialstudies-6-js","44":"component---src-pages-socialstudies-7-js","45":"component---src-pages-socialstudies-8-js","46":"component---src-pages-spanish-js","47":"component---src-pages-termsofuse-js","48":"component---src-pages-timer-20-js","49":"component---src-templates-article-js","50":"component---src-templates-articles-js","51":"component---src-templates-subjects-js","52":"e9227503"}[chunkId]||chunkId) + "." + {"0":"15c5dab73e848180a04f","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
